<template>
  <div>
    <h4>MARA Premium</h4>
    <form @submit.prevent="save">
      <div class="mb-3">
        <b-checkbox
          v-model="form.is_premium"
          switch
          :disabled="loading"
          class="mb-3"
        >
          Enable Premium Demo
        </b-checkbox>
        <NanInput
          v-model="form.expires_at"
          :disabled="!form.is_premium"
          label="Premium Expires At"
          type="date"
          class="mb-3"
        />
        <b-textarea v-model="emails" placeholder="Apply to additional emails" />
        <small class="small text-muted">
          One email per line. Will override current premium status and
          expiration.
        </small>
      </div>
      <div class="text-right">
        <b-btn
          :disabled="!hasChanges || !form.expires_at || loading"
          variant="primary"
          type="submit"
        >
          Save
        </b-btn>
      </div>
    </form>
    <hr />
    <h4>Add Credits</h4>
    <form class="d-flex" @submit.prevent="addCredits">
      <b-select
        v-model="amount"
        :options="[25, 50, 100, 200, 500, 1000]"
        class="mr-2"
      />
      <b-btn
        :disabled="!amount"
        class="text-nowrap"
        variant="primary"
        type="submit"
      >
        Add Credits
      </b-btn>
    </form>
  </div>
</template>

<script>
import API from "@/api";

export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    amount: null,
    emails: "",
    form: {
      is_premium: false,
      expires_at: null
    },
    loading: false
  }),

  computed: {
    currentExpiresAt() {
      return this.user.mara_premium_expires_at
        ? new Date(this.user.mara_premium_expires_at)
            .toISOString()
            .substr(0, 10)
        : null;
    },
    hasChanges() {
      return (
        this.form.is_premium !== !!this.user.mara_premium ||
        this.form.expires_at !== this.currentExpiresAt
      );
    }
  },

  watch: {
    user: {
      handler() {
        this.form.is_premium = !!this.user.mara_premium;
        this.form.expires_at = this.currentExpiresAt;
      },
      immediate: true
    }
  },

  methods: {
    async addCredits() {
      await API.adminMaraAddCredits(this.user.email, this.amount);
      this.$emit("update");
    },
    async save() {
      this.loading = true;
      const emails = this.emails.split("\n").filter(Boolean);
      for (const email of [this.user.email, ...emails]) {
        await API.adminMaraSetPremium(
          email,
          this.form.is_premium,
          this.form.expires_at
        ).catch(() => {});
      }
      this.loading = false;
      this.$emit("update");
    }
  }
};
</script>
